import React from "react";
import "./Contact.scss";

function Contact() {
  return (
    <div>
      <h1 id="contact" className="contactUs">
        Contact us
      </h1>
      <hr className="hruLe" />
      <div className="mainCont">
        <div class="shadowing">
          <div class="cardingggs">
            <div
              class="card-header"
              style={{
                fontFamily: "Lato, sans-serif",
              }}
            >
              Contact
            </div>
            <div class="card-body">
              <dl>
                <span class="spanning">
                  <dt>
                    <a href="/">
                      <svg
                        class="icon"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        width="27"
                        height="27"
                      >
                        <path
                          fill="#4289ff"
                          d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm-6-6c0-2.209 1.791-4 4-4s4 1.791 4 4v1c0 2.209-1.791 4-4 4s-4-1.791-4-4v-1zm4-10c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2z"
                        />
                      </svg>
                    </a>
                  </dt>
                  <dd
                    style={{
                      fontFamily: "Lato, sans-serif",
                    }}
                  >
                    <a
                      href="#home"
                      style={{
                        textDecoration: "none",
                        color: "black",
                      }}
                    >
                      @gururaj_construction
                    </a>
                  </dd>
                </span>
                <span class="spanning">
                  <dt>
                    <a href="mailto:constructiongururaj@gmail.com">
                      <svg
                        t="1580195271469"
                        class="icon"
                        viewBox="0 0 1025 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="9773"
                        width="27"
                        height="27"
                      >
                        <path
                          d="M1024.073143 405.723429l0 453.705143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-841.142857 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-453.705143q25.161143 28.013714 57.709714 49.737143 206.848 140.580571 284.013714 197.12 32.548571 23.990857 52.882286 37.449143t53.979429 27.428571 62.829714 13.970286l1.170286 0q29.110857 0 62.829714-13.970286t53.979429-27.428571 52.882286-37.449143q97.133714-70.290286 284.598857-197.12 32.548571-22.308571 57.124571-49.737143zM1024.073143 237.714286q0 45.129143-28.013714 86.308571t-69.705143 70.290286q-214.820571 149.138286-267.410286 185.709714-5.705143 4.022857-24.283429 17.408t-30.866286 21.723429-29.696 18.578286-32.841143 15.433143-28.598857 5.12l-1.170286 0q-13.165714 0-28.598857-5.12t-32.841143-15.433143-29.696-18.578286-30.866286-21.723429-24.283429-17.408q-52.004571-36.571429-149.723429-104.301714t-117.174857-81.408q-35.401143-23.990857-66.852571-65.974857t-31.451429-77.970286q0-44.544 23.698286-74.313143t67.730286-29.696l841.142857 0q37.156571 0 64.292571 26.843429t27.136 64.585143z"
                          p-id="9774"
                          fill="#4289ff"
                        ></path>
                      </svg>
                    </a>
                  </dt>
                  <dd>
                    {" "}
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                      }}
                      href="mailto:constructiongururaj@gmail.com"
                    >
                      constructiongururaj@gmail.com
                    </a>
                  </dd>
                </span>
                <span class="spanning">
                  <dt>
                    <a href="tel:+919630197666">
                      <svg
                        t="1580195271469"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="10241"
                        width="27"
                        height="27"
                      >
                        <path
                          d="M914.285714 708.534857q0 15.433143-5.705143 40.301714t-11.995429 39.131429q-11.995429 28.598857-69.705143 60.562286-53.686857 29.110857-106.276571 29.110857-15.433143 0-29.988571-1.974857t-32.841143-7.168-27.136-8.265143-31.744-11.702857-28.013714-10.313143q-56.027429-19.968-99.986286-47.396571-73.142857-45.129143-151.113143-123.172571t-123.172571-151.113143q-27.428571-44.032-47.396571-99.986286-1.682286-5.12-10.313143-28.013714t-11.702857-31.744-8.265143-27.136-7.168-32.841143-1.974857-29.988571q0-52.589714 29.110857-106.276571 32.036571-57.709714 60.562286-69.705143 14.262857-6.290286 39.131429-11.995429t40.301714-5.705143q7.972571 0 11.995429 1.682286 10.313143 3.437714 30.281143 43.446857 6.290286 10.825143 17.115429 30.866286t19.968 36.278857 17.700571 30.573714q1.682286 2.267429 10.020571 14.262857t12.288 20.260571 4.022857 16.310857q0 11.410286-16.310857 28.598857t-35.401143 31.451429-35.401143 30.281143-16.310857 26.258286q0 5.12 2.852571 12.873143t4.827429 11.702857 7.972571 13.677714 6.582857 10.825143q43.446857 78.262857 99.401143 134.290286t134.290286 99.401143q1.170286 0.585143 10.825143 6.582857t13.677714 7.972571 11.702857 4.827429 12.873143 2.852571q10.313143 0 26.258286-16.310857t30.281143-35.401143 31.451429-35.401143 28.598857-16.310857q7.972571 0 16.310857 4.022857t20.260571 12.288 14.262857 10.020571q14.262857 8.557714 30.573714 17.700571t36.278857 19.968 30.866286 17.115429q40.009143 19.968 43.446857 30.281143 1.682286 4.022857 1.682286 11.995429z"
                          p-id="10242"
                          fill="#4289ff"
                        ></path>
                      </svg>
                    </a>
                  </dt>
                  <dd
                    style={{
                      fontFamily: "Lato, sans-serif",
                    }}
                  >
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                      }}
                      href="tel:+919630197666"
                    >
                      +91 9630197666
                    </a>
                  </dd>
                </span>
                <span class="spanning">
                  <dt>
                    <a href="tel:+917000697745">
                      <svg
                        t="1580195271469"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="10241"
                        width="27"
                        height="27"
                      >
                        <path
                          d="M914.285714 708.534857q0 15.433143-5.705143 40.301714t-11.995429 39.131429q-11.995429 28.598857-69.705143 60.562286-53.686857 29.110857-106.276571 29.110857-15.433143 0-29.988571-1.974857t-32.841143-7.168-27.136-8.265143-31.744-11.702857-28.013714-10.313143q-56.027429-19.968-99.986286-47.396571-73.142857-45.129143-151.113143-123.172571t-123.172571-151.113143q-27.428571-44.032-47.396571-99.986286-1.682286-5.12-10.313143-28.013714t-11.702857-31.744-8.265143-27.136-7.168-32.841143-1.974857-29.988571q0-52.589714 29.110857-106.276571 32.036571-57.709714 60.562286-69.705143 14.262857-6.290286 39.131429-11.995429t40.301714-5.705143q7.972571 0 11.995429 1.682286 10.313143 3.437714 30.281143 43.446857 6.290286 10.825143 17.115429 30.866286t19.968 36.278857 17.700571 30.573714q1.682286 2.267429 10.020571 14.262857t12.288 20.260571 4.022857 16.310857q0 11.410286-16.310857 28.598857t-35.401143 31.451429-35.401143 30.281143-16.310857 26.258286q0 5.12 2.852571 12.873143t4.827429 11.702857 7.972571 13.677714 6.582857 10.825143q43.446857 78.262857 99.401143 134.290286t134.290286 99.401143q1.170286 0.585143 10.825143 6.582857t13.677714 7.972571 11.702857 4.827429 12.873143 2.852571q10.313143 0 26.258286-16.310857t30.281143-35.401143 31.451429-35.401143 28.598857-16.310857q7.972571 0 16.310857 4.022857t20.260571 12.288 14.262857 10.020571q14.262857 8.557714 30.573714 17.700571t36.278857 19.968 30.866286 17.115429q40.009143 19.968 43.446857 30.281143 1.682286 4.022857 1.682286 11.995429z"
                          p-id="10242"
                          fill="#4289ff"
                        ></path>
                      </svg>
                    </a>
                  </dt>
                  <dd
                    style={{
                      fontFamily: "Lato, sans-serif",
                    }}
                  >
                    <a
                      href="tel:+917000697745"
                      style={{
                        textDecoration: "none",
                        color: "black",
                      }}
                    >
                      +91 7000697745
                    </a>
                  </dd>
                </span>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
